import { render, staticRenderFns } from "./Cuenta.vue?vue&type=template&id=2dcb35a0"
import script from "./Cuenta.vue?vue&type=script&lang=js"
export * from "./Cuenta.vue?vue&type=script&lang=js"
import style0 from "./Cuenta.vue?vue&type=style&index=0&id=2dcb35a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports